import { Component, enableProdMode, inject, Injector, NgModule, OnInit, ChangeDetectionStrategy } from "@angular/core";
import { UtilApiAuthComponent } from './security/util-api-auth.component';
import { RouterOutlet } from '@angular/router';
import { environment, companyList } from '../environments/util-environment';
import { appPages, moduleConfigs, orm, routes } from './app.routes';
import { jkGlb, JkGlbClass, LazyLoadingService, OrmService } from 'jk-service';
import { sysPages, sysRoutes } from 'sys';
import { CommonModule } from '@angular/common';
import { taxPages, taxRoutes } from 'tax';
import { mtrPages, mtrRoutes } from 'mtr';
import { jckPages, jckRoutes } from 'jck';
import { utyPages, utyRoutes } from 'uty';
import { HttpClient } from '@angular/common/http';

import { AllCommunityModule, ModuleRegistry } from 'ag-grid-community';
ModuleRegistry.registerModules([AllCommunityModule]);

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [RouterOutlet, UtilApiAuthComponent],// ### 多加 CommonModule
  templateUrl: './app.component.html',
  styleUrl: './app.component.css'
,
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class AppComponent implements OnInit {
  private lazyLoadingService = inject(LazyLoadingService);
  http = inject(HttpClient);

  orm: OrmService = inject(OrmService);//###
  constructor() {
    this.lazyLoadingService.setModuleConfigs(moduleConfigs);
    this.appInit();
  }

  async ngOnInit() { //###
    // Start preloading critical modules after app initialization
    try {
      await this.lazyLoadingService.preloadAllModules();
    } catch (error) {
      console.error('Error preloading critical modules:', error);
    }
  }

  appInit() {//###
    // Only add pages to the menu, routes are now handled by lazy loading
    appPages.unshift(...sysPages);
    appPages.unshift(...taxPages);
    appPages.unshift(...mtrPages);
    appPages.unshift(...jckPages);
    appPages.unshift(...utyPages);

    jkGlb.init(false, environment as any, companyList, appPages, this.orm); //###

  }

}

@NgModule({
  declarations: [],
  imports: [CommonModule, AppComponent,// HttpClientModule,
    //  QuillModule.forRoot()
  ],
  providers: [], // ###jackie add provideHttpClient()
  exports: [],
})
export class AppModule { }

